/* global $ */
import Headroom from 'headroom.js'

import './jquery.slicknav.js'

import './slicknav.css'

const appendLangMenuToMobileNav = (slickNavElem) => {
  const desktopLangMenu = document.querySelector('.main-navigation .lang-menu')
  if (!desktopLangMenu || !slickNavElem) return

  const slickNavList = slickNavElem.querySelector('.slicknav_nav')
  if (!slickNavList || slickNavList.querySelector('.slicknav_lang-menu')) return

  const clonedLangMenu = desktopLangMenu.cloneNode(true)
  clonedLangMenu.classList.add('lang-menu--mobile')

  const langMenuListItem = document.createElement('li')
  langMenuListItem.className = 'slicknav_lang-menu'
  langMenuListItem.appendChild(clonedLangMenu)

  slickNavList.appendChild(langMenuListItem)
}

const setSlickNav = async () => {
  $('#menu').slicknav({
    closedSymbol: '+',
    openedSymbol: '<span class="opened">-</span>',
    closeOnClick: true
  })

  const slickNavElem = document.querySelector('.slicknav_menu')
  if (!slickNavElem) return

  const logo = document.querySelector('.logo')
  if (logo && !slickNavElem.querySelector('.slicknav_menu__logo')) {
    const logoElem = document.createElement('div')
    logoElem.className = 'slicknav_menu__logo'
    logoElem.innerHTML = logo.innerHTML
    slickNavElem.appendChild(logoElem)
  }

  appendLangMenuToMobileNav(slickNavElem)

  return slickNavElem
}

const setHeadroom = (slickNavElem) => {
  if (slickNavElem) {
    const headroom = new Headroom(slickNavElem, {
      offset: 200,
      tolerance: 5,
      classes: {
        // When element is initialised
        initial: 'headroom--mobile',
        // When scrolling up
        pinned: 'headroom--pinned--mobile',
        // When scrolling down
        unpinned: 'headroom--unpinned--mobile'
      },
      // Cancel unpin when Slick nav is open
      onUnpin: function () {
        if ($('.slicknav_open')[0]) this.pin()
      }
    })
    headroom.init()
  }
}

const init = async () => {
  await setSlickNav().then(setHeadroom) // Initialize SlickNav, then set headroom
}

export default {
  init
}
